import { WaitingScreen } from '@/features/waiting/WaitingScreen';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/waiting')({
  staticData: { nav: 'waiting' },
  validateSearch: z.object({
    reason: z.string().optional(),
    assignee: z.string().optional(),
    status: z.string().optional(),
  }),
  component: WaitingScreen,
});
